var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCubeSolid = function SvgCubeSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    className: "svgr-icon"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m16 4.406-.406.188-10 4.5-.594.25V22.03l.5.282 10 5.562.5.281.5-.281 10-5.562.5-.282V9.344l-.594-.25-10-4.5Zm0 2.188 7.688 3.437L16 13.875l-7.687-3.844Zm-9 5.031 8 4v9.656l-8-4.437Zm18 0v9.219l-8 4.437v-9.656Z"
  })));
};
export default SvgCubeSolid;